<template>
    <div class="ui modal" :id="id">
        <div class="header">
            <i class="icon" :class="classes"></i>
            {{titulo}}
        </div>
        <div class="content">
            {{mensaje}}
            <br/>
            <error :data="errorMensajes" v-if="error"></error>
        </div>
        <div class="actions">
            <div class="ui negative button" :class="{loading: loading}">
                {{cancelText}}
            </div>
            <div class="ui positive rigth lebeled icon button" :class="{loading: loading}">
                {{okText}}
                <i class="checkmark icon"></i>
            </div>
        </div>
    </div>
</template>
<script>
  export default {
    data () {
      return {}
    },
    /**
     * closeOnSucces: indica si el modal se debe cerrar de manera automatica en cuanto se presiona ok
     * okText: texto del boton positivo
     * cancelText: texto del boton negativo
     * loading: indica si el proceso del modal esta corriendo, por defecto si el parametro closeOnSucces es false, este parametro se pone en true
     * cuando se presiona el boton positivo
     * error: indica si el componente debe mostrar errores
     * errorMensajes: son los mensajes de error que debe mostrar el componente
     */
    props: ['id', 'titulo', 'icono', 'mensaje', 'closeOnSucces', 'okText', 'cancelText', 'loading', 'modalOptions', 'error', 'errorMensajes'],
    mounted () {
      let internalOptions = {
        closable: false,
        onApprove: this.positive,
        onDeny: this.negative,
        onHide: () => {
          this.$emit('update:loading', false)
        }
      }

      this.modalInstance = jQuery(this.$el).modal(jQuery.extend(true, internalOptions, this.modalOptions || {}))
    },
    methods: {
      positive: function () {
        if (this.loading) return false
        this.$emit('action', {
          action: 'positive'
        })
        if (!this.closeOnSucces) {
          this.$emit('update:loading', true)
          return false
        }
      },
      negative: function () {
        if (this.loading) return false
        this.$emit('action', {
          action: 'negative'
        })
      }
    },
    destroyed: function () {
      this.modalInstance.remove()
    },
    computed: {
      classes: function () {
        let c = {}
        if (this.icono) {
          c[this.icono] = true
        }
        return c
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/ui/confirm-modal/ConfirmModal.vue